import { configConstants } from "../constants";

const initialState = {
  docsActiveTabs: Array(21).fill("0"),
  docsInstances: Array(21).fill(null),
  docDeliveryData: Array(21).fill(null),
  filterStr: "",
  isNewCustomer: false,
  editMode: false,
  newCustomerData: {
    GlobalId: "",
    Name: "",
    SAPId: "",
    SNCId: "",
    Country: "",
    Language: "",
    LegacyIds: [],
    Projects: [],
    Contacts: [],
  },

  activeTab: "1",
  selCustomerConfigReportsPageNumber: 1,
  selCustomerConfigReportsSize: 20,

  modalConfirm: false,
  confirmDialogHandler: null,

  modalEditConfigReport: false,
  reportForEdit: null,
  reportForEditDef: null,

  modalCopyNewConfigReport: false,
  reportForCopyNew: null,
  reportForCopyNewDef: null,

  allProjects: [],

  expandedCustomers: [],
  defaultSearchPeriod: -1,
  docsViewActiveTabs: "1",
  excelUploadYear: "",

  tagsOptions: [],
  tagsIcons: {
    read: "eye",
    test: "bug",
    paid: "wallet",
  },

  reportsDescriptions: [],
};

export function config(state = initialState, action) {
  switch (action.type) {
    case configConstants.GET_UPLOAD_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case configConstants.GET_UPLOAD_LIST_SUCCESS:
      return {
        ...state,
        lastUploads: action.lastUploads,
      };
    case configConstants.GET_UPLOAD_LIST_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    case configConstants.TOGGLE_DOCS_VIEW_ACTIVE_TAB:
      return {
        ...state,
        docsViewActiveTabs: action.tab,
      };
    case configConstants.SET_EXCEL_UPLOAD_YEAR:
      return {
        ...state,
        excelUploadYear: action.excelUploadYear,
      };
    case configConstants.SET_TAGS_OPTIONS:
      return {
        ...state,
        tagsOptions: action.tagsOptions,
        tagsIcons: action.tagsIcons || {
          read: "eye",
          test: "bug",
          paid: "wallet",
        },
      };
    case configConstants.SET_DEFAULT_SEARCH_PERIOD:
      return {
        ...state,
        defaultSearchPeriod: action.defaultSearchPeriod,
      };
    case configConstants.TOGGLE_EXPAND_CUSTOMER:
      var array = state.expandedCustomers.slice(0);
      var index = array.indexOf(action.id);
      if (index > -1) {
        array.splice(index, 1);
      } else {
        array.push(action.id);
      }
      return {
        ...state,
        expandedCustomers: array,
      };

    case configConstants.GETALL_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case configConstants.GET_REPORTS_DESCS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case configConstants.GET_REPORTS_DESCS_SUCCESS:
      return {
        ...state,
        loading: false,
        reportsDescriptions: action.reportsDescriptions,
      };

    case configConstants.GETACTIVE_CUSTOMERS_REQUEST:
      return {
        ...state,
        loadingActiveCustomers: true,
      };
    case configConstants.GET_ALL_CUSTOMER_REQUEST:
      return {
        ...state,
        loading_all_customer: true,
      };
    case configConstants.GETALL_CUSTOMERS_SUCCESS:
      return {
        ...state,
        allCustomers: buildTreeList(action.customers),
        loading_all_customer: false,
      };

    case configConstants.CLEAR_FILTER_FILES_SEARCH_CUSTOMERS:
      return {
        ...state,
        filesViewCustomers: (state.customers || []).slice(0),
      };
    case configConstants.CLEAR_FILTER_DOCUMENTS_SEARCH_CUSTOMERS:
      return {
        ...state,
        docsViewCustomers: (state.customers || []).slice(0),
      };

    case configConstants.FILTER_FILES_SEARCH_CUSTOMERS:
      return {
        ...state,
        filesViewCustomers: action.customers,
      };
    case configConstants.FILTER_DOCUMENTS_SEARCH_CUSTOMERS:
      return {
        ...state,
        docsViewCustomers: action.customers,
      };
    case configConstants.GETACTIVE_CUSTOMERS_SUCCESS:
      // iterate throw all customers and add project to filesViewProject, docsViewProjects, execReportsViewProjects
      let allProjects = action.projects || [];
      action.customers.forEach((item) => {
        (item.projects || []).forEach((customerProj) => {
          if (
            !allProjects.find((o) => o.projectId === customerProj.projectId)
          ) {
            allProjects.push(customerProj);
          }
        });
        //allProjects = allProjects.concat((item.projects || []).slice(0));
      });
      if (action.keepProjFilter) {
        let filesViewProjects = allProjects.slice(0);
        if (action.storeState.fileSearch.CustomerId) {
          filesViewProjects = action.customers
            .filter(
              (item) =>
                item.globalId === action.storeState.fileSearch.CustomerId
            )[0]
            .projects.slice(0);
        }
        let docsViewProjects = allProjects.slice(0);
        if (action.storeState.docSearch.CustomerId) {
          docsViewProjects = action.customers
            .filter(
              (item) => item.globalId === action.storeState.docSearch.CustomerId
            )[0]
            .projects.slice(0);
        }

        let dashboardViewProjects = allProjects.slice(0);
        if (action.storeState.dashboardSearch.CustomerId) {
          dashboardViewProjects = action.customers
            .filter(
              (item) =>
                item.globalId === action.storeState.dashboardSearch.CustomerId
            )[0]
            .projects.slice(0);
        }
        return {
          ...state,
          customers: action.customers,
          filesViewCustomers: action.customers,
          docsViewCustomers: action.customers,
          loadingActiveCustomers: false,
          allProjects,
          filesViewProjects,
          docsViewProjects,
          dashboardViewProjects,
        };
      } else {
        return {
          ...state,
          customers: action.customers,
          filesViewCustomers: action.customers,
          docsViewCustomers: action.customers,
          //dashboardViewCustomers: action.customers,
          loadingActiveCustomers: false,
          allProjects,
          filesViewProjects: allProjects.slice(0),
          docsViewProjects: allProjects.slice(0),
          dashboardViewProjects: allProjects.slice(0),
        };
      }

    case configConstants.FILTER_PROJECTS_BY_CUSTOMERID:
      //globalId
      let cutomerItem = state.customers.filter(
        (item) => item.globalId === action.globalId
      )[0];
      if (action.view === "filesView") {
        return {
          ...state,
          filesViewProjects: (cutomerItem.projects || []).slice(0),
        };
      } else if (action.view === "documentsView") {
        return {
          ...state,
          docsViewProjects: (cutomerItem.projects || []).slice(0),
        };
      } else if (action.view === "dashboardView") {
        return {
          ...state,
          dashboardViewProjects: (cutomerItem.projects || []).slice(0),
        };
      } else {
        return state;
      }
    case configConstants.GETALL_CHANNELS_SUCCESS:
      return { ...state, channels: action.channels, loading: false };
    case configConstants.GET_PLATFORMNAMES_SUCCESS:
      return { ...state, platformNames: action.platformNames, loading: false };

    case configConstants.GET_FILES_PROJECTS_SUCCESS:
      return { ...state, filesViewProjects: action.projects, loading: false };
    case configConstants.GET_DOCS_PROJECTS_SUCCESS:
      return { ...state, docsViewProjects: action.projects, loading: false };
    case configConstants.GET_CONFIG_CUSTOMER_DATA_SUCCESS:
      // add childList if there to the selectedcustomerinfo
      var _childList =
        ((state.allCustomers || []).filter(
          (x) => x.oId === action.data._id
        )[0] || {})["childList"] || [];
      return {
        ...state,
        selectedCustomerInfo: action.data,
        selectedCustomerGlobalId: action.data.GlobalId,
        selectedCustomerName: action.data.Name,
        selectedCustomerChildList: _childList,
        loading: false,
      };

    case configConstants.GET_EXEC_REPORTS_PROJECTS_SUCCESS:
      return {
        ...state,
        execReportsViewProjects: action.projects,
        loading: false,
      };
    case configConstants.GET_CONFIG_REPORTS_PROJECTS_SUCCESS:
      return {
        ...state,
        configReportsViewProjects: action.projects,
        loading: false,
      };
    case configConstants.GET_DASHBOARD_PROJECTS_SUCCESS:
      return {
        ...state,
        dashboardViewProjects: action.projects,
        loading: false,
      };
    case configConstants.GET_WIZARD_PROJECTS_SUCCESS:
      return { ...state, wizardViewProjects: action.projects, loading: false };

    case configConstants.GET_CUSTOMER_CONFIG_REPORTS_SUCCESS:
      return {
        ...state,
        selCustomerConfiguredReports: action.reports,
        selCustomerConfigReportsTotalPages: action.TotalPages,
      };
    case configConstants.SET_SELE_CUST_CONFIG_REPOPRTS_PAGE_NUMBER:
      return {
        ...state,
        selCustomerConfigReportsPageNumber: action.pageNumber,
      };
    case configConstants.SET_CUSTOMER_CONFIG_REPORT_ACTIVE_ROW:
      if (
        state.selCustomerConfiguredReports &&
        state.selCustomerConfiguredReports.length
      ) {
        var oldActiveRow = state.selCustomerConfiguredReports.filter(function (
          obj
        ) {
          return obj.isActive;
        })[0];

        if (oldActiveRow) {
          oldActiveRow.isActive = false;
        }

        let _item = state.selCustomerConfiguredReports[action.rowIndex];
        _item.isActive = true;
      }
      return { ...state };

    case configConstants.UPDATE_CONFIG_CUSTOMER_DATA:
      if (state.selectedCustomerInfo) {
        if (action.field === "GlobalId") {
          return { ...state, selectedCustomerGlobalId: action.value };
        } else if (action.field === "Name") {
          return { ...state, selectedCustomerName: action.value };
        } else {
          var _selectedCustomerInfo = Object.assign(
            {},
            state.selectedCustomerInfo
          );
          _selectedCustomerInfo[action.field] = action.value;
          return {
            ...state,
            selectedCustomerInfo: _selectedCustomerInfo,
          };
        }
      }
      return state;
    case configConstants.RESET_CONFIG_SELECTED_CUSTOMER:
      return {
        ...state,
        selectedCustomerInfo: null,
        selectedCustomerGlobalId: null,
        selectedCustomerName: null,
      };

    case configConstants.UPDATE_CONFIG_NEW_CUSTOMER_DATA:
      if (state.newCustomerData) {
        var _newCustomerData = Object.assign({}, state.newCustomerData);
        _newCustomerData[action.field] = action.value;
        return { ...state, newCustomerData: _newCustomerData };
      }
      return state;
    case configConstants.RESET_CONFIG_NEW_CUSTOMER:
      return {
        ...state,
        selCustomerConfiguredReports: [],
        newCustomerData: { ...initialState.newCustomerData },
      };

    case configConstants.SET_FILTER_STR:
      return { ...state, filterStr: action.filterStr };

    case configConstants.SET_NEW_CUSTOMER_STATUS:
      return { ...state, isNewCustomer: action.isNewCustomer };

    case configConstants.TOGGLE_CUSTOMER_ACTIVE_TAB:
      return { ...state, activeTab: action.tab };

    case configConstants.TOGGLE_MODAL_CONFIRM:
      return { ...state, modalConfirm: action.modalConfirm };

    case configConstants.SET_CONFIRM_DIALOG_HANDLER:
      return { ...state, confirmDialogHandler: action.confirmDialogHandler };

    case configConstants.TOGGLE_MODAL_EDIT_CONFIG_REPORT:
      const reportForEditDef =
        action.repDescObjRef || state.reportForEditDef || null;
      return {
        ...state,
        modalEditConfigReport: action.isOpen,
        reportForEdit: action.report || null,
        reportForEditDef,
      };

    case configConstants.TOGGLE_MODAL_COPY_NEW_CONFIG_REPORT:
      return {
        ...state,
        modalCopyNewConfigReport: action.isOpen,
        reportForCopyNew: action.report || null,
        reportForCopyNewDef: action.repDescObjRef || null,
      };

    case configConstants.SET_CUSTOMER_EDIT_MODE:
      return { ...state, editMode: action.editMode };

    case configConstants.ACTIVATE_CONFIG_CUSTOMER:
      if (state.selectedCustomerInfo) {
        var _selCustomerInfo = Object.assign({}, state.selectedCustomerInfo);
        _selCustomerInfo["act"] = true;
        return { ...state, selectedCustomerInfo: _selCustomerInfo };
      }
      return state;

    case configConstants.DEACTIVATE_CONFIG_CUSTOMER:
      if (state.selectedCustomerInfo) {
        var _sCustomerInfo = Object.assign({}, state.selectedCustomerInfo);
        _sCustomerInfo["act"] = false;
        return { ...state, selectedCustomerInfo: _sCustomerInfo };
      }
      return state;

    case configConstants.RESET_VIEWS_PROJECTS:
      return {
        ...state,
        filesViewProjects: [],
        docsViewProjects: [],
        execReportsViewProjects: [],
        configReportsViewProjects: [],
        dashboardViewProjects: [],
        wizardViewProjects: [],
      };

    case configConstants.RESET_FILES_VIEWS_PROJECTS:
      return { ...state, filesViewProjects: state.allProjects.slice(0) };

    case configConstants.RESET_DOCS_VIEWS_PROJECTS:
      return { ...state, docsViewProjects: state.allProjects.slice(0) };

    case configConstants.RESET_EXEC_REPORTS_VIEWS_PROJECTS:
      return { ...state, execReportsViewProjects: [] };

    case configConstants.RESET_CONFIG_REPORTS_VIEWS_PROJECTS:
      return { ...state, configReportsViewProjects: [] };

    case configConstants.RESET_DASHBOARD_VIEWS_PROJECTS:
      return { ...state, dashboardViewProjects: state.allProjects.slice(0) };

    case configConstants.RESET_WIZARD_VIEWS_PROJECTS:
      return { ...state, wizardViewProjects: [] };

    case configConstants.RESET_DOCS_ACTIVE_TAB:
      return { ...state, docsActiveTabs: Array(21).fill("0") };
    case configConstants.TOGGLE_DOCS_ACTIVE_TAB:
      if (state.docsActiveTabs[action.index] !== action.tab) {
        const activeTabs = state.docsActiveTabs.slice();
        activeTabs[action.index] = action.tab;
        return { ...state, docsActiveTabs: activeTabs };
      }
      return state;

    case configConstants.RESET_DOCS_INSTANCES:
      return { ...state, docsInstances: Array(21).fill(null) };

    case configConstants.RESET_DOC_BOUNCEBACKS:
      return { ...state, docDeliveryData: Array(21).fill(null) };

    case configConstants.UPDATE_DOCS_INSTANCES:
      const updatedDocsInstances = state.docsInstances.slice();
      updatedDocsInstances[action.index] = action.instances;
      return { ...state, docsInstances: updatedDocsInstances };

    case configConstants.GET_DOCUMENT_CHANNEL_DELIVERY_DATA: {
      const updateddocDeliveryData = state.docDeliveryData.slice();
      updateddocDeliveryData[action.index] = action.docDeliveryData;
      return { ...state, docDeliveryData: updateddocDeliveryData };
    }

    case configConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
}

var buildTreeList = (customers) => {
  var _customers = customers.slice(0);
  var map = {},
    node,
    roots = [],
    i;
  for (i = 0; i < _customers.length; i += 1) {
    map[_customers[i].oId] = i; // initialize the map
    _customers[i].childList = []; // initialize the children
  }
  for (i = 0; i < _customers.length; i += 1) {
    node = _customers[i];
    if (node.parentId) {
      _customers[map[node.parentId]].childList.push(node);
    } else {
      roots.push(node);
    }
  }
  return roots;
};
